var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"status--button",class:[
    {
      'status--draft': _vm.data === 'draft',
      'status--paid': _vm.data === 'paid',
      'status--pending': _vm.data === 'pending',
    } ],attrs:{"v-model":_vm.data}},[_c('span',{staticClass:"status-dot"}),_vm._v(" "+_vm._s(_vm.data)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }